import React from 'react';
import { Col} from 'reactstrap';

const nameCheck = {
	fontWeight: '900',
	paddingLeft: '8px',
};

const criticalCheck = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden' }} >


		<h2 className="text-heading-giveAssured">Critical Checks Before Listing</h2>
		<p>Every nonprofit has a set of requisite qualifiers which are essential to its listing and continued presence on the site.</p>
		<p>The most critical evaluation parameter is where we understand and verify how the nonprofit implements, monitors, and reviews its programs so that there is integrity in their results and there is effective tracking of expenses incurred. </p>


		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/legal.png" alt="Legal" /> <span style={{ ...nameCheck }}>Legal</span></p>
		<p>We will make sure that the organisation meets all requirements of the law of the land is a registered legal entity. All documents of incorporation, identity and applicable licenses are physically verified for accuracy.
		</p>
		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/compliance.png" alt="Compliance" /> <span style={{ ...nameCheck }}>Compliance</span></p>
		<p>The organisation should have undergone a minimum of one audit cycle and filed one set of tax returns to ensure that the organisation has been checked at least once by a third party and there are no serious notations in the reports.
		</p>
		<p>The audited financials for upto three years are physically verified to understand the health of the organisation as well as to check if there are serious concerns raised by their auditor. Any concerns raised by the auditors are checked and only after satisfactory clarification, we proceed with the listing.
		</p>
		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/monitoring-and-evaluation.png" alt="Monitoring & Evaluation" /> <span style={{ ...nameCheck }}>Monitoring & Evaluation’ (M&E)</span></p>
		<p>Nonprofits are assessed for verifiable records </p>
		<ul>
		<li><p> Of beneficiaries and benefits the program offers them</p></li>
	<li>	<p>Of Payments made to its employees </p></li>
		<li><p> That no donations raised through us are used for political or religious activities.</p></li>
		</ul>
		<p>Nonprofits are assessed for financial aspects like </p>
		<ul>
	<li>	<p> Making sure that more than 70% of expenses made through a non-cash medium</p></li>
	<li>	<p> Verifiable records of accounts and expenses which they will make available for us as requested </p></li>
		<li><p>Components of cost covered by donations made by our donors cannot have an alternate donor </p></li>
    </ul>

		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/corporate-governance.png" alt="Corporate Governance" /> <span style={{ ...nameCheck }}>Corporate Governance </span></p>
		<ul>
		<li><p>Verifiable records of board meetings, attendance and minutes. </p></li>
		</ul>

		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/fin-process.png" alt="Systems & Process - Financial Information" /> <span style={{ ...nameCheck }}>Systems & Process - Financial Information </span>
		</p>
		<p>Check of financial process is done on ground through periodic visits to the nonprofit partners across 23 states of the country.
		</p>
		<ul>
	<li>	<p> We review the accounting structure, total income and expenditure incurred  by programs and the organisation in the past two years.
		</p></li>
		<li><p> For already listed nonprofits, we do the verification with specific focus on GiveIndia funds related expenses against a random selection of vouchers and bills.
		</p></li>
	<li>	<p> We enforce a maximum cap on the cash expenses that can be made using donations received through GiveIndia. We verify adherence to this aspect as well.
	</p></li>
		</ul>

		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/prg-implementation.png" alt="Systems & Process - Program Implementation" /> <span style={{ ...nameCheck }}>Systems & Process - Program Implementation</span></p>

	<ul>
	<li><p> We check the on-ground implementation of the listed program through visits to project site and interaction with employees who manage the program
		</p></li>
	<li>	<p> We verify how the organization tracks its beneficiaries as well as the impact of the program.
		</p></li>
		</ul>

		<p><img className="critical-check-image" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/ben-verification.png" alt="Systems & Process - Verification" /> <span style={{ ...nameCheck }}>Systems & Process - Verification</span></p>
		<ul>
		<li><p> We visit the beneficiaries in person to reconfirm benefits without prior intimation to the NGO
		</p></li>
		</ul>
		<p>Our team travels across the length and the breadth of the country  to make sure that we do these checks so you can give with trust. We travel across the country no matter how remote the areas of execution are, to make sure that the program works the way it is meant to.
		</p>

		<style global jsx>
			{
				`
   .critical-check-image{
		 width: 60px;
		 height: 60px;
		 padding-top:20px;
	 }


			`
			}
		</style>
	</Col>


);

export default criticalCheck;
